/**
 * Orders Repository (ADR-0009).
 */

import { queueBusinessPayloadFieldWrite } from '../storage/businessPayloadWrite';
import { publishDomainEvent, DOMAIN_EVENTS } from '../events/domainEventBus';
import {
  readOrdersFromBestSource,
  refreshOrdersReadCache
} from '../../utils/ordersReadSource';

export class KvOrdersRepository {
  /**
   * @param {string} businessId
   */
  async listOrders(businessId) {
    return readOrdersFromBestSource(businessId);
  }

  /**
   * @param {string} businessId
   * @param {Array} orders
   */
  async replaceOrders(businessId, orders) {
    const next = Array.isArray(orders) ? orders : [];
    await queueBusinessPayloadFieldWrite(businessId, 'orders', next);
    await refreshOrdersReadCache(businessId);
    publishDomainEvent(DOMAIN_EVENTS.ORDERS_UPDATED, { businessId, orders: next });
    return next;
  }
}
